// packages/web/src/hooks/useTermSelection.ts
// Hook for managing term selection state

import { useState, useCallback } from 'react';

import { MarketplaceService } from '../types/pricing';

interface UseTermSelectionResult {
  selectedTerm: number | null;
  setSelectedTerm: (term: number | null) => void;
  handleTermChange: (term: number) => void;
  availableTerms: number[];
}

export const useTermSelection = (service: MarketplaceService | null): UseTermSelectionResult => {
  const [selectedTerm, setSelectedTerm] = useState<number | null>(
    service?.default_term_months || service?.contract_term_months?.[0] || null,
  );

  const handleTermChange = useCallback((term: number) => {
    setSelectedTerm(term);
  }, []);

  const availableTerms = service?.contract_term_months || [];

  return {
    selectedTerm,
    setSelectedTerm,
    handleTermChange,
    availableTerms,
  };
};
